import { useEventCallback, useUpdateEffect } from '@cian/react-utils';

import { type FC, useState } from 'react';

import { usePageSelector } from '@/packages/redux-state/store/slices/jsonQuery';

import { InfinityLoaderAreaContainer } from './InfinityLoaderAreaContainer';
import { PaginationContainer } from './PaginationContainer';

type TInfinityLoadMode = 'infinity' | 'button';

export const ListingPaginationContainer: FC = () => {
  const [infinityLoadMode, setInfinityLoadMode] = useState<TInfinityLoadMode>('infinity');

  const switchOnInfinityLoadMode = useEventCallback(() => {
    setInfinityLoadMode('infinity');
  });

  const switchOnButtonLoadMode = useEventCallback(() => {
    setInfinityLoadMode('button');
  });

  const page = usePageSelector();

  useUpdateEffect(() => {
    /**
     * @description
     * При сбросе страницы возвращаем начальный стейт
     */
    if (page === 1) {
      switchOnInfinityLoadMode();
    }
  }, [page]);

  return (
    <>
      <InfinityLoaderAreaContainer
        mode={infinityLoadMode}
        onButtonClick={switchOnInfinityLoadMode}
        onLoaderReached={switchOnButtonLoadMode}
      />

      <PaginationContainer onPageClick={switchOnInfinityLoadMode} />
    </>
  );
};
